// import React, { useEffect, useState, useCallback, useRef } from "react";
// import { ImUpload } from "react-icons/im";
// import Diamond from "../../../assets/Diamond.png";
// import { NavLink } from "react-router-dom";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import apiKey from "../../../config/apiKey";
// import axios from "axios";
// import { toast } from "react-toastify";

// const StuProfile = () => {
//   const student = JSON.parse(localStorage.getItem("edo-student"));

//   const [isLoading, setIsLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [classes, setClasses] = useState([]);
//   const [errorsUser, setErrorsUser] = useState({});
//   const [loading, setLoading] = useState(true);

//   const user = {
//     email: student ? student.student.email : "",
//     id: student ? student.student.id : "",
//   };

//   // ====== NEW: local skills tags state ======
//   const [skillsInput, setSkillsInput] = useState("");

//   const [formData, setFormData] = useState({
//     // existing
//     name: "",
//     phone: "",
//     email: user.email || "",
//     institute: "",
//     address: "",
//     country: "",
//     city: "",
//     state: "",
//     zip: "",
//     class_id: "",

//     // NEW fields
//     user_type: "",              // 'undergrad' | 'grad' | 'professional'
//     degree_subject: "",
//     years_experience: "",
//     experience_summary: "",
//     university: "",
//     skills: [],                 // array of strings
//   });

//   const [formUser, setFormUser] = useState({ name: "", phone: "" });
//   const [profileImage, setProfileImage] = useState(null);

//   // Google Places
//   const autocompleteRef = useRef(null);
//   const initPlaces = useCallback(() => {
//     if (!window.google || !autocompleteRef.current) return;
//     const autocomplete = new window.google.maps.places.Autocomplete(
//       autocompleteRef.current,
//       {
//         componentRestrictions: { country: "pk" },
//         fields: ["address_components", "formatted_address"],
//       }
//     );
//     autocomplete.addListener("place_changed", () => {
//       const place = autocomplete.getPlace();
//       const parts = place.address_components || [];
//       const pick = (t) =>
//         parts.find((c) => c.types.includes(t))?.long_name || "";

//       setFormData((prev) => ({
//         ...prev,
//         address: place.formatted_address || prev.address,
//         country: pick("country") || prev.country,
//         city: pick("locality") || prev.city,
//         state: pick("administrative_area_level_1") || prev.state,
//         zip: pick("postal_code") || prev.zip,
//       }));
//     });
//   }, []);
//   useEffect(() => {
//     initPlaces();
//   }, [initPlaces]);

//   // Data fetches
//   useEffect(() => {
//     axios
//       .get(`${apiKey}/api/edolutions/classes`)
//       .then((res) => setClasses(res.data || []))
//       .catch((err) => console.error(err));
//   }, []);

//   useEffect(() => {
//     setLoading(true);
//     axios
//       .get(`${apiKey}/api/edolutions/student/getuser/${user.id}`, {
//         headers: { Authorization: `Bearer ${student?.token}` },
//       })
//       .then((res) => {
//         setFormUser(res.data || {});
//         if (res.data?.updated === 1) {
//           axios
//             .get(`${apiKey}/api/edolutions/student/student-profile`, {
//               headers: { Authorization: `Bearer ${student?.token}` },
//             })
//             .then((r) => {
//               if (r.data?.[0]) {
//                 const p = r.data[0];
//                 // NOTE: backend should now return new fields as well
//                 setFormData((prev) => ({
//                   ...prev,
//                   email: p.email || prev.email,
//                   institute: p.institute || "",
//                   university: p.university || "",          // NEW
//                   user_type: p.user_type || "",            // NEW
//                   degree_subject: p.degree_subject || "",  // NEW
//                   years_experience:
//                     p.years_experience !== null && p.years_experience !== undefined
//                       ? String(p.years_experience)
//                       : "",
//                   experience_summary: p.experience_summary || "",
//                   skills: Array.isArray(p.skills) ? p.skills : [],

//                   address: p.address || "",
//                   country: p.country || "",
//                   city: p.city || "",
//                   state: p.state || "",
//                   zip: p.zip || "",
//                   class_id: p.class_id || "",
//                 }));
//               }
//             })
//             .catch((e) => console.error("profile fetch:", e));
//         } else {
//           setFormData((prev) => ({
//             ...prev,
//             class_id: res.data?.class_id || "",
//           }));
//         }
//       })
//       .catch((err) => console.error("user fetch:", err))
//       .finally(() => setLoading(false));
//   }, [student?.token, user.id]);

//   useEffect(() => {
//     axios
//       .get(`${apiKey}/api/edolutions/student/student-profile`, {
//         headers: { Authorization: `Bearer ${student?.token}` },
//       })
//       .then((res) => {
//         if (res.data?.[0]?.photo_url) setProfileImage(res.data[0].photo_url);
//       })
//       .catch((err) => console.error(err));
//   }, [student?.token]);

//   // Handlers
//   const handleChangeUser = (e) => {
//     setFormUser((p) => ({ ...p, [e.target.name]: e.target.value }));
//     setErrorsUser((p) => ({ ...p, [e.target.name]: "" }));
//   };
//   const handleChange = (e) => {
//     setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
//     setErrors((p) => ({ ...p, [e.target.name]: "" }));
//   };
//   const handleChangeClass = (e) => {
//     const { name, value } = e.target;
//     setFormData((p) => ({ ...p, [name]: value }));
//     setErrors((p) => ({ ...p, [name]: "" }));
//   };

//   // ====== NEW: skills pills handlers ======
//   const addSkillFromInput = () => {
//     const s = skillsInput.trim();
//     if (!s) return;
//     if (formData.skills.includes(s)) {
//       setSkillsInput("");
//       return;
//     }
//     setFormData((p) => ({ ...p, skills: [...p.skills, s] }));
//     setSkillsInput("");
//   };
//   const handleSkillsKeyDown = (e) => {
//     if (e.key === "Enter" || e.key === ",") {
//       e.preventDefault();
//       addSkillFromInput();
//     }
//   };
//   const removeSkill = (i) => {
//     setFormData((p) => ({ ...p, skills: p.skills.filter((_, idx) => idx !== i) }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     // finalize any pending input in skills box
//     if (skillsInput.trim()) addSkillFromInput();

//     const updatedFormUser = {
//       ...formUser,
//       updated: "1",
//       class_id: formData.class_id,
//     };

//     try {
//       await Promise.all([
//         axios.post(
//           `${apiKey}/api/edolutions/student/student-profile`,
//           {
//             // server expects this flat payload (store() accepts these)
//             email: formData.email,
//             institute:formData.university,
//             university: formData.university,           // NEW
//             address: formData.address,
//             country: formData.country,
//             city: formData.city,
//             state: formData.state,
//             zip: formData.zip,
//             class_id: formData.class_id,

//             user_type: formData.user_type,             // NEW
//             degree_subject: formData.degree_subject,   // NEW
//             years_experience:
//               formData.years_experience === ""
//                 ? null
//                 : Number(formData.years_experience),   // NEW
//             experience_summary: formData.experience_summary, // NEW
//             skills: formData.skills,                   // NEW (array)

//             first_name: formUser.name?.split(" ")?.[0] || formUser.name || "",
//             last_name: formUser.name?.split(" ")?.slice(1).join(" ") || "",
//             phone: formUser.phone || "",
//             photo: null,
//           },
//           { headers: { Authorization: `Bearer ${student?.token}` } }
//         ),

//         axios.put(
//           `${apiKey}/api/edolutions/student/updateuser/${user.id}`,
//           updatedFormUser,
//           { headers: { Authorization: `Bearer ${student?.token}` } }
//         ),
//       ]);

//       toast.success("Profile updated successfully", {
//         position: "bottom-right",
//         autoClose: 3800,
//         theme: "colored",
//         style: { backgroundColor: "#2A3A54", color: "#fff" },
//       });
 
//     } catch (err) {
//       if (err.response) {
//         if (err.response.data?.errors) setErrorsUser(err.response.data.errors);
//         if (err.response.data?.data) setErrors(err.response.data.data);
//       } else setErrors({ general: "An unexpected error occurred" });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleImageUpload = (e) => {
//     const f = e.target.files?.[0];
//     if (!f) return;
//     const fd = new FormData();
//     fd.append("photo", f);

//     axios
//       .post(`${apiKey}/api/edolutions/student/student_image`, fd, {
//         headers: { Authorization: `Bearer ${student?.token}` },
//       })
//       .then((res) => {
//         toast.success(res.data.message, {
//           position: "bottom-right",
//           autoClose: 3600,
//           theme: "colored",
//           style: { backgroundColor: "#2A3A54", color: "#fff" },
//         });
//         return axios.get(`${apiKey}/api/edolutions/student/student-profile`, {
//           headers: { Authorization: `Bearer ${student?.token}` },
//         });
//       })
//       .then((r) => {
//         if (r.data?.[0]?.photo_url) setProfileImage(r.data[0].photo_url);
//       })
//       .catch((err) => {
//         toast.error(err.response?.data?.message || "Upload failed", {
//           position: "bottom-right",
//           autoClose: 3600,
//           theme: "colored",
//         });
//       });
//   };

//   // UI bits
//   const LoaderCard = () => (
//     <div className="animate-pulse">
//       <div className="w-32 h-32 bg-gray-200 rounded-full mx-auto" />
//       <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto mt-4" />
//       <div className="h-4 bg-gray-200 rounded w-1/3 mx-auto mt-2" />
//     </div>
//   );

//   return (
//     <div className="flex items-center xl:p-5 sm:p-0 justify-center pb-12">
//       <div className="flex flex-wrap w-full justify-center border rounded-3xl shadow-xl bg-white">
//         {/* LEFT */}
//         <aside className="w-full xl:w-1/3 p-6">
//           <div className="rounded-3xl border shadow-sm p-6 bg-white/80">
//             {/* Accent ribbon */}
//             <div className="h-1 w-24 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] mb-6 mx-auto" />
//             {loading ? (
//               <LoaderCard />
//             ) : (
//               <>
//                 <div className="flex flex-col items-center justify-center">
//                   <img
//                     className="rounded-full border w-40 h-40 object-cover shadow-sm"
//                     src={
//                       profileImage
//                         ? profileImage
//                         : `${apiKey}/userProfile/87654321.png`
//                     }
//                     alt="Profile"
//                   />
//                   <div className="relative mt-3">
//                     <input
//                       type="file"
//                       id="uploadBtn"
//                       accept="image/*"
//                       onChange={handleImageUpload}
//                       className="hidden"
//                     />
//                     <label
//                       htmlFor="uploadBtn"
//                       className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm text-white cursor-pointer shadow bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//                     >
//                       <ImUpload /> Upload
//                     </label>
//                   </div>
//                 </div>

//                 <div className="text-center mt-4">
//                   <p className="text-2xl font-semibold">{formUser.name}</p>
//                   <p className="text-sm font-medium text-[#979CA5] mt-1">
//                     Mentee
//                   </p>
//                 </div>

//                 <hr className="my-6" />

//                 <p className="text-lg font-semibold mb-3 text-center">
//                   Account Settings
//                 </p>

//                 <div className="mx-2 grid gap-3">
//                   <NavLink to="">
//                     <div className="flex items-center bg-white border rounded-xl px-4 gap-2 py-2.5 shadow-sm hover:shadow transition">
//                       <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
//                     <p>Edit Profile</p>
//                     </div>
//                   </NavLink>
//                 </div>
//               </>
//             )}
//           </div>
//         </aside>

//         {/* RIGHT */}
//         <section className="xl:w-2/3 p-6 border-l">
//           {/* Header stripe */}
//           <div className="flex items-center justify-between mb-4">
//             <p className="text-2xl font-bold">Profile Details</p>
//             <span className="h-1 w-36 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
//           </div>
//           <hr className="mb-6" />

//           {loading ? (
//             <div className="p-8">
//               <div className="animate-pulse space-y-4">
//                 <div className="h-6 bg-gray-200 rounded w-1/3" />
//                 <div className="h-10 bg-gray-200 rounded" />
//                 <div className="h-10 bg-gray-200 rounded" />
//                 <div className="h-10 bg-gray-200 rounded" />
//               </div>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit} className="space-y-8">
//               {/* Basic Info */}
//               <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
//                 <div className="flex items-center gap-3 mb-4">
//                   <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
//                   <p className="text-lg font-semibold">Basic Information</p>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   <div>
//                     <input
//                       type="text"
//                       placeholder="Full Name"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
//                       name="name"
//                       value={formUser.name || ""}
//                       onChange={handleChangeUser}
//                     />
//                     {errorsUser?.name && (
//                       <p className="text-red-500 text-sm mt-1">
//                         {errorsUser.name[0]}
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="Email"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-100 text-gray-500 cursor-not-allowed"
//                       name="email"
//                       value={formData.email || ""}
//                       onChange={handleChange}
//                       disabled={Boolean(formData.email)}
//                     />
//                     {errors?.email && (
//                       <p className="text-red-500 text-sm mt-1">
//                         *email is required!
//                       </p>
//                     )}
//                   </div>

//                   {/* <div>
//                     <input
//                       type="text"
//                       placeholder="Institute Name"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
//                       name="institute"
//                       value={formData.institute || ""}
//                       onChange={handleChange}
//                     />
//                     {errors?.institute && (
//                       <p className="text-red-500 text-sm mt-1">
//                         *Institute name is required!
//                       </p>
//                     )}
//                   </div> */}

//                   <div>
//                     <PhoneInput
//                       containerStyle={{ width: "100%" }}
//                       dropdownStyle={{ top: "auto" }}
//                       inputStyle={{
//                         width: "100%",
//                         height: "44px",
//                         borderRadius: "12px",
//                         background: "#F9FBFF",
//                         borderColor: "#E5E7EB",
//                       }}
//                       placeholder="Phone"
//                       country={"pk"}
//                       inputProps={{ required: true, name: "phone" }}
//                       value={formUser.phone || ""}
//                       onChange={(val) =>
//                         setFormUser((prev) => ({ ...prev, phone: val }))
//                       }
//                     />
//                     {errorsUser?.phone && (
//                       <p className="text-red-500 text-sm mt-1">
//                         {errorsUser.phone[0]}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* Education & Experience (NEW) */}
//               <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
//                 <div className="flex items-center gap-3 mb-4">
//                   <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
//                   <p className="text-lg font-semibold">Education & Experience</p>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   <div>
//                     <select
//                       name="user_type"
//                       value={formData.user_type || ""}
//                       onChange={handleChange}
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
//                     >
//                       <option value="">Select Education Level</option>
//                       <option value="undergrad">Undergraduate</option>
//                       <option value="grad">Graduate</option>
//                       <option value="professional">Professional</option>
//                     </select>
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="Degree Subject (e.g., Computer Science)"
//                       name="degree_subject"
//                       value={formData.degree_subject || ""}
//                       onChange={handleChange}
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
//                     />
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="University"
//                       name="university"
//                       value={formData.university || ""}
//                       onChange={handleChange}
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
//                     />
//                   </div>

//                   <div>
//                     <input
//                       type="number"
//                       min="0"
//                       max="60"
//                       placeholder="Years of Experience"
//                       name="years_experience"
//                       value={formData.years_experience}
//                       onChange={handleChange}
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
//                     />
//                   </div>

//                   <div className="sm:col-span-2">
//                     <textarea
//                       rows={3}
//                       placeholder="Experience Summary (e.g., Internships, Roles, Highlights)"
//                       name="experience_summary"
//                       value={formData.experience_summary || ""}
//                       onChange={handleChange}
//                       className="border w-full rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
//                     />
//                   </div>

//                   {/* Skills pills */}
//                   <div className="sm:col-span-2">
//                     <label className="block text-sm font-semibold mb-2">
//                       Skills (press Enter or comma to add)
//                     </label>
//                     <div className="border rounded-xl bg-gray-50 p-2 flex flex-wrap gap-2">
//                       {formData.skills.map((s, i) => (
//                         <span
//                           key={`${s}-${i}`}
//                           className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs border bg-white"
//                         >
//                           {s}
//                           <button
//                             type="button"
//                             onClick={() => removeSkill(i)}
//                             className="text-gray-500 hover:text-red-500"
//                             title="Remove"
//                           >
//                             ×
//                           </button>
//                         </span>
//                       ))}
//                       <input
//                         value={skillsInput}
//                         onChange={(e) => setSkillsInput(e.target.value)}
//                         onKeyDown={handleSkillsKeyDown}
//                         placeholder="e.g., React, Node.js"
//                         className="flex-1 min-w-[160px] bg-transparent outline-none px-2 py-1"
//                       />
//                       <button
//                         type="button"
//                         onClick={addSkillFromInput}
//                         className="text-xs font-medium px-3 py-1.5 rounded-full text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//                       >
//                         Add
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Address */}
//               <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
//                 <div className="flex items-center gap-3 mb-4">
//                   <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
//                   <p className="text-lg font-semibold">Address</p>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   <div className="sm:col-span-2">
//                     <input
//                       id="location-input"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
//                       placeholder="Address"
//                       type="text"
//                       name="address"
//                       value={formData.address || ""}
//                       onChange={handleChange}
//                       ref={autocompleteRef}
//                     />
//                     {errors?.address && (
//                       <p className="text-red-500 text-sm mt-1">
//                         *Address is required!
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="Country"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
//                       name="country"
//                       value={formData.country || ""}
//                       onChange={handleChange}
//                     />
//                     {errors?.country && (
//                       <p className="text-red-500 text-sm mt-1">
//                         *Country name is required!
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="City"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
//                       name="city"
//                       value={formData.city || ""}
//                       onChange={handleChange}
//                     />
//                     {errors?.city && (
//                       <p className="text-red-500 text-sm mt-1">
//                         *City name is required!
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="State/Province"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
//                       name="state"
//                       value={formData.state || ""}
//                       onChange={handleChange}
//                     />
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="ZIP / Postal Code"
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
//                       name="zip"
//                       value={formData.zip || ""}
//                       onChange={handleChange}
//                     />
//                     {errors?.zip && (
//                       <p className="text-red-500 text-sm mt-1">
//                         *Zip Code is required!
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* Class & Save */}
//               <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
//                 <div className="flex items-center gap-3 mb-4">
//                   <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
//                   <p className="text-lg font-semibold">Profession</p>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   <div>
//                     <select
//                       className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
//                       onChange={handleChangeClass}
//                       name="class_id"
//                       value={formData.class_id || ""}
//                     >
//                       <option value="">Select Class</option>
//                       {classes.map((c, idx) => (
//                         <option key={idx} value={c.id}>
//                           {c.class_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 <div className="flex justify-end mt-6">
//                   <button
//                     type="submit"
//                     className={`w-fit px-6 py-2.5 rounded-xl font-medium text-white shadow hover:opacity-95 transition
//                     bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]
//                     ${isLoading ? "opacity-60 cursor-not-allowed" : ""}`}
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <svg
//                         className="animate-spin h-5 w-5 inline-block"
//                         xmlns="http://www.w3.org/2000/svg"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                       >
//                         <circle
//                           className="opacity-25"
//                           cx="12"
//                           cy="12"
//                           r="10"
//                           stroke="currentColor"
//                           strokeWidth="4"
//                         ></circle>
//                         <path
//                           className="opacity-75"
//                           fill="currentColor"
//                           d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                         ></path>
//                       </svg>
//                     ) : (
//                       "Save Profile"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           )}
//         </section>
//       </div>
//     </div>
//   );
// };

// export default StuProfile;



import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ImUpload } from "react-icons/im";
import { NavLink } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import apiKey from "../../../config/apiKey";
import axios from "axios";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";

const StuProfile = () => {
  const { t } = useTranslation();
  const student = JSON.parse(localStorage.getItem("edo-student"));

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [classes, setClasses] = useState([]);
  const [errorsUser, setErrorsUser] = useState({});
  const [loading, setLoading] = useState(true);

  const user = {
    email: student ? student.student.email : "",
    id: student ? student.student.id : "",
  };

  // All available skills from backend
  const [skillsOptions, setSkillsOptions] = useState([]);

  const [formData, setFormData] = useState({
    // existing
    name: "",
    phone: "",
    email: user.email || "",
    institute: "",
    address: "",
    country: "",
    city: "",
    state: "",
    zip: "",
    class_id: "",

    // NEW fields
    user_type: "", // 'undergrad' | 'grad' | 'professional'
    degree_subject: "",
    years_experience: "",
    experience_summary: "",
    university: "",
    skills: [], // array of strings (names)
  });

  const [formUser, setFormUser] = useState({ name: "", phone: "" });
  const [profileImage, setProfileImage] = useState(null);

  // Google Places
  const autocompleteRef = useRef(null);
  const initPlaces = useCallback(() => {
    if (!window.google || !autocompleteRef.current) return;
    const autocomplete = new window.google.maps.places.Autocomplete(
      autocompleteRef.current,
      {
        componentRestrictions: { country: "pk" },
        fields: ["address_components", "formatted_address"],
      }
    );
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      const parts = place.address_components || [];
      const pick = (t) =>
        parts.find((c) => c.types.includes(t))?.long_name || "";

      setFormData((prev) => ({
        ...prev,
        address: place.formatted_address || prev.address,
        country: pick("country") || prev.country,
        city: pick("locality") || prev.city,
        state: pick("administrative_area_level_1") || prev.state,
        zip: pick("postal_code") || prev.zip,
      }));
    });
  }, []);
  useEffect(() => {
    initPlaces();
  }, [initPlaces]);

  // Data fetches
  useEffect(() => {
    axios
      .get(`${apiKey}/api/edolutions/classes`)
      .then((res) => setClasses(res.data || []))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${apiKey}/api/edolutions/student/getuser/${user.id}`, {
        headers: { Authorization: `Bearer ${student?.token}` },
      })
      .then((res) => {
        setFormUser(res.data || {});
        if (res.data?.updated === 1) {
          axios
            .get(`${apiKey}/api/edolutions/student/student-profile`, {
              headers: { Authorization: `Bearer ${student?.token}` },
            })
            .then((r) => {
              if (r.data?.[0]) {
                const p = r.data[0];
                setFormData((prev) => ({
                  ...prev,
                  email: p.email || prev.email,
                  institute: p.institute || "",
                  university: p.university || "",
                  user_type: p.user_type || "",
                  degree_subject: p.degree_subject || "",
                  years_experience:
                    p.years_experience !== null &&
                    p.years_experience !== undefined
                      ? String(p.years_experience)
                      : "",
                  experience_summary: p.experience_summary || "",
                  skills: Array.isArray(p.skills) ? p.skills : [],

                  address: p.address || "",
                  country: p.country || "",
                  city: p.city || "",
                  state: p.state || "",
                  zip: p.zip || "",
                  class_id: p.class_id || "",
                }));
              }
            })
            .catch((e) => console.error("profile fetch:", e));
        } else {
          setFormData((prev) => ({
            ...prev,
            class_id: res.data?.class_id || "",
          }));
        }
      })
      .catch((err) => console.error("user fetch:", err))
      .finally(() => setLoading(false));
  }, [student?.token, user.id]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/edolutions/student/student-profile`, {
        headers: { Authorization: `Bearer ${student?.token}` },
      })
      .then((res) => {
        if (res.data?.[0]?.photo_url) setProfileImage(res.data[0].photo_url);
      })
      .catch((err) => console.error(err));
  }, [student?.token]);

  // 🔹 Load all skills for dropdown
  useEffect(() => {
    if (!student?.token) return;

    axios
      .get(`${apiKey}/api/edolutions/student/skills`, {
        // tum yeh endpoint bana loge
        headers: { Authorization: `Bearer ${student?.token}` },
      })
      .then((res) => {
        const list = res.data || [];
        const opts = list.map((s) => ({
          value: s.skill_name, // backend se skill_name bhejna
          label: s.skill_name,
        }));
        setSkillsOptions(opts);
      })
      .catch((err) => console.error("skills fetch error:", err));
  }, [student?.token]);

  // Handlers
  const handleChangeUser = (e) => {
    setFormUser((p) => ({ ...p, [e.target.name]: e.target.value }));
    setErrorsUser((p) => ({ ...p, [e.target.name]: "" }));
  };
  const handleChange = (e) => {
    setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
    setErrors((p) => ({ ...p, [e.target.name]: "" }));
  };
  const handleChangeClass = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const updatedFormUser = {
      ...formUser,
      updated: "1",
      class_id: formData.class_id,
    };

    try {
      await Promise.all([
        axios.post(
          `${apiKey}/api/edolutions/student/student-profile`,
          {
            email: formData.email,
            institute: formData.university,
            university: formData.university,
            address: formData.address,
            country: formData.country,
            city: formData.city,
            state: formData.state,
            zip: formData.zip,
            class_id: formData.class_id,

            user_type: formData.user_type,
            degree_subject: formData.degree_subject,
            years_experience:
              formData.years_experience === ""
                ? null
                : Number(formData.years_experience),
            experience_summary: formData.experience_summary,
            skills: formData.skills, // array of names

            first_name:
              formUser.name?.split(" ")?.[0] || formUser.name || "",
            last_name:
              formUser.name?.split(" ")?.slice(1).join(" ") || "",
            phone: formUser.phone || "",
            photo: null,
          },
          { headers: { Authorization: `Bearer ${student?.token}` } }
        ),

        axios.put(
          `${apiKey}/api/edolutions/student/updateuser/${user.id}`,
          updatedFormUser,
          { headers: { Authorization: `Bearer ${student?.token}` } }
        ),
      ]);

      toast.success(t("studentDash.homeProfile.profileUpdatedSuccessfully"), {
        position: "bottom-right",
        autoClose: 3800,
        theme: "colored",
        style: { backgroundColor: "#2A3A54", color: "#fff" },
      });
    } catch (err) {
      if (err.response) {
        if (err.response.data?.errors)
          setErrorsUser(err.response.data.errors);
        if (err.response.data?.data) setErrors(err.response.data.data);
      } else setErrors({ general: t("studentDash.homeProfile.unexpectedError") });
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageUpload = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const fd = new FormData();
    fd.append("photo", f);

    axios
      .post(`${apiKey}/api/edolutions/student/student_image`, fd, {
        headers: { Authorization: `Bearer ${student?.token}` },
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 3600,
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });
        return axios.get(`${apiKey}/api/edolutions/student/student-profile`, {
          headers: { Authorization: `Bearer ${student?.token}` },
        });
      })
      .then((r) => {
        if (r.data?.[0]?.photo_url) setProfileImage(r.data[0].photo_url);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || t("studentDash.homeProfile.uploadFailed"), {
          position: "bottom-right",
          autoClose: 3600,
          theme: "colored",
        });
      });
  };

  // UI bits
  const LoaderCard = () => (
    <div className="animate-pulse">
      <div className="w-32 h-32 bg-gray-200 rounded-full mx-auto" />
      <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto mt-4" />
      <div className="h-4 bg-gray-200 rounded w-1/3 mx-auto mt-2" />
    </div>
  );

  // Selected skills ko options format me convert karein
  const selectedSkillOptions = [
    ...skillsOptions.filter((opt) => formData.skills.includes(opt.value)),
    ...formData.skills
      .filter((s) => !skillsOptions.some((opt) => opt.value === s))
      .map((s) => ({ value: s, label: s })),
  ];

  return (
    <div className="flex items-center xl:p-5 sm:p-0 justify-center pb-12">
      <div className="flex flex-wrap w-full justify-center border rounded-3xl shadow-xl bg-white">
        {/* LEFT */}
        <aside className="w-full xl:w-1/3 p-6">
          <div className="rounded-3xl border shadow-sm p-6 bg-white/80">
            <div className="h-1 w-24 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] mb-6 mx-auto" />
            {loading ? (
              <LoaderCard />
            ) : (
              <>
                <div className="flex flex-col items-center justify-center">
                  <img
                    className="rounded-full border w-40 h-40 object-cover shadow-sm"
                    src={
                      profileImage
                        ? profileImage
                        : `${apiKey}/userProfile/87654321.png`
                    }
                    alt={t("studentDash.homeProfile.profileAlt")}
                  />
                  <div className="relative mt-3">
                    <input
                      type="file"
                      id="uploadBtn"
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="hidden"
                    />
                    <label
                      htmlFor="uploadBtn"
                      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm text-white cursor-pointer shadow bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
                    >
                      <ImUpload /> {t("studentDash.homeProfile.upload")}
                    </label>
                  </div>
                </div>

                <div className="text-center mt-4">
                  <p className="text-2xl font-semibold">{formUser.name}</p>
                  <p className="text-sm font-medium text-[#979CA5] mt-1">
                    {t("studentDash.homeProfile.mentee")}
                  </p>
                </div>

                <hr className="my-6" />

                <p className="text-lg font-semibold mb-3 text-center">
                  {t("studentDash.homeProfile.accountSettings")}
                </p>

                <div className="mx-2 grid gap-3">
                  <NavLink to="">
                    <div className="flex items-center bg-white border rounded-xl px-4 gap-2 py-2.5 shadow-sm hover:shadow transition">
                      <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
                      <p>{t("studentDash.homeProfile.editProfile")}</p>
                    </div>
                  </NavLink>
                </div>
              </>
            )}
          </div>
        </aside>

        {/* RIGHT */}
        <section className="xl:w-2/3 p-6 border-l">
          <div className="flex items-center justify-between mb-4">
            <p className="text-2xl font-bold">{t("studentDash.homeProfile.profileDetails")}</p>
            <span className="h-1 w-36 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
          </div>
          <hr className="mb-6" />

          {loading ? (
            <div className="p-8">
              <div className="animate-pulse space-y-4">
                <div className="h-6 bg-gray-200 rounded w-1/3" />
                <div className="h-10 bg-gray-200 rounded" />
                <div className="h-10 bg-gray-200 rounded" />
                <div className="h-10 bg-gray-200 rounded" />
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Basic Info */}
              <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
                  <p className="text-lg font-semibold">{t("studentDash.homeProfile.basicInformation")}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.fullNamePlaceholder")}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
                      name="name"
                      value={formUser.name || ""}
                      onChange={handleChangeUser}
                    />
                    {errorsUser?.name && (
                      <p className="text-red-500 text-sm mt-1">
                        {errorsUser.name[0]}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.emailPlaceholder")}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-100 text-gray-500 cursor-not-allowed"
                      name="email"
                      value={formData.email || ""}
                      onChange={handleChange}
                      disabled={Boolean(formData.email)}
                    />
                    {errors?.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {t("studentDash.homeProfile.emailRequired")}
                      </p>
                    )}
                  </div>

                  <div>
                    <PhoneInput
                      containerStyle={{ width: "100%" }}
                      dropdownStyle={{ top: "auto" }}
                      inputStyle={{
                        width: "100%",
                        height: "44px",
                        borderRadius: "12px",
                        background: "#F9FBFF",
                        borderColor: "#E5E7EB",
                      }}
                      placeholder={t("studentDash.homeProfile.phonePlaceholder")}
                      country={"pk"}
                      inputProps={{ required: true, name: "phone" }}
                      value={formUser.phone || ""}
                      onChange={(val) =>
                        setFormUser((prev) => ({ ...prev, phone: val }))
                      }
                    />
                    {errorsUser?.phone && (
                      <p className="text-red-500 text-sm mt-1">
                        {errorsUser.phone[0]}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Education & Experience */}
              <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
                  <p className="text-lg font-semibold">{t("studentDash.homeProfile.educationExperience")}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <select
                      name="user_type"
                      value={formData.user_type || ""}
                      onChange={handleChange}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
                    >
                      <option value="">{t("studentDash.homeProfile.selectEducationLevel")}</option>
                      <option value="undergrad">{t("studentDash.homeProfile.undergraduate")}</option>
                      <option value="grad">{t("studentDash.homeProfile.graduate")}</option>
                      <option value="professional">{t("studentDash.homeProfile.professional")}</option>
                    </select>
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.degreeSubjectPlaceholder")}
                      name="degree_subject"
                      value={formData.degree_subject || ""}
                      onChange={handleChange}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
                    />
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.universityPlaceholder")}
                      name="university"
                      value={formData.university || ""}
                      onChange={handleChange}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
                    />
                  </div>

                  <div>
                    <input
                      type="number"
                      min="0"
                      max="60"
                      placeholder={t("studentDash.homeProfile.yearsExperiencePlaceholder")}
                      name="years_experience"
                      value={formData.years_experience}
                      onChange={handleChange}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
                    />
                  </div>

                  <div className="sm:col-span-2">
                    <textarea
                      rows={3}
                      placeholder={t("studentDash.homeProfile.experienceSummaryPlaceholder")}
                      name="experience_summary"
                      value={formData.experience_summary || ""}
                      onChange={handleChange}
                      className="border w-full rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
                    />
                  </div>

                  {/* Skills Select */}
                  <div className="sm:col-span-2">
                    <label className="block text-sm font-semibold mb-2">
                      {t("studentDash.homeProfile.selectYourSkills")}
                    </label>
                    <CreatableSelect
                      isMulti
                      isClearable
                      options={skillsOptions}
                      value={selectedSkillOptions}
                      placeholder={t("studentDash.homeProfile.selectOrTypeSkills")}
                      classNamePrefix="cabil-skills"
                      onChange={(selected) => {
                        const names = (selected || []).map(
                          (opt) => opt.value
                        );
                        setFormData((prev) => ({
                          ...prev,
                          skills: names,
                        }));
                      }}
                      onCreateOption={async (inputValue) => {
                        const name = inputValue.trim();
                        if (!name) return;
                        if (formData.skills.includes(name)) return;

                        try {
                          await axios.post(
                            `${apiKey}/api/edolutions/student/skills`,
                            { skill_name: name },
                            {
                              headers: {
                                Authorization: `Bearer ${student?.token}`,
                              },
                            }
                          );

                          const newOpt = { value: name, label: name };
                          setSkillsOptions((prev) => [...prev, newOpt]);
                          setFormData((prev) => ({
                            ...prev,
                            skills: [...prev.skills, name],
                          }));
                        } catch (err) {
                          console.error("create skill error:", err);
                          toast.error(t("studentDash.homeProfile.unableToAddSkill"), {
                            position: "bottom-right",
                            autoClose: 3500,
                            theme: "colored",
                          });
                        }
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: 44,
                          borderRadius: 12,
                          borderColor: "#E5E7EB",
                          backgroundColor: "#F9FBFF",
                          boxShadow: "none",
                          ":hover": { borderColor: "#EE5F2B" },
                        }),
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Address */}
              <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
                  <p className="text-lg font-semibold">{t("studentDash.homeProfile.address")}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="sm:col-span-2">
                    <input
                      id="location-input"
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
                      placeholder={t("studentDash.homeProfile.address")}
                      type="text"
                      name="address"
                      value={formData.address || ""}
                      onChange={handleChange}
                      ref={autocompleteRef}
                    />
                    {errors?.address && (
                      <p className="text-red-500 text-sm mt-1">
                        {t("studentDash.homeProfile.addressRequired")}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.countryPlaceholder")}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
                      name="country"
                      value={formData.country || ""}
                      onChange={handleChange}
                    />
                    {errors?.country && (
                      <p className="text-red-500 text-sm mt-1">
                        {t("studentDash.homeProfile.countryRequired")}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.cityPlaceholder")}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
                      name="city"
                      value={formData.city || ""}
                      onChange={handleChange}
                    />
                    {errors?.city && (
                      <p className="text-red-500 text-sm mt-1">
                        {t("studentDash.homeProfile.cityRequired")}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.stateProvincePlaceholder")}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
                      name="state"
                      value={formData.state || ""}
                      onChange={handleChange}
                    />
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder={t("studentDash.homeProfile.zipPlaceholder")}
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#EE5F2B]/30"
                      name="zip"
                      value={formData.zip || ""}
                      onChange={handleChange}
                    />
                    {errors?.zip && (
                      <p className="text-red-500 text-sm mt-1">
                        {t("studentDash.homeProfile.zipRequired")}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Class & Save */}
              <div className="rounded-2xl border p-5 bg-white/80 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
                  <p className="text-lg font-semibold">{t("studentDash.homeProfile.profession")}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <select
                      className="border h-11 w-full rounded-xl px-4 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2A3A54]/30"
                      onChange={handleChangeClass}
                      name="class_id"
                      value={formData.class_id || ""}
                    >
                      <option value="">{t("studentDash.homeProfile.selectClass")}</option>
                      {classes.map((c, idx) => (
                        <option key={idx} value={c.id}>
                          {c.class_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex justify-end mt-6">
                  <button
                    type="submit"
                    className={`w-fit px-6 py-2.5 rounded-xl font-medium text-white shadow hover:opacity-95 transition
                    bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]
                    ${isLoading ? "opacity-60 cursor-not-allowed" : ""}`}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <svg
                        className="animate-spin h-5 w-5 inline-block"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    ) : (
                      t("studentDash.homeProfile.saveProfile")
                    )}
                  </button>
                </div>
              </div>
            </form>
          )}
        </section>
      </div>
    </div>
  );
};

export default StuProfile;
